<div class="main-area">
  <div class="wf-action-bar">
    <div class="wf-action-id">
      <span class="id-label">ID</span>
      <span class="id-val">{{ workflow.id }}</span>
    </div>
    <div class="wf-action-btns">
      <button class="btn-action btn-dup" (click)="duplicateWorkflow()" title="Duplicate">
        <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
          <rect x="1" y="4" width="7" height="8" rx="1.5" stroke="currentColor" stroke-width="1.2" />
          <path d="M4 4V2.5A1.5 1.5 0 0 1 5.5 1H10.5A1.5 1.5 0 0 1 12 2.5V7.5A1.5 1.5 0 0 1 10.5 9H9" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" />
        </svg>
        Duplicate
      </button>
      <button class="btn-action btn-del" (click)="deleteWorkflow()" title="Remove">
        <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
          <path d="M2 4h9M5 4V2.5h3V4M4 4l.5 6.5h4L9 4" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        Remove
      </button>
    </div>
  </div>

  <div class="config-panel">
    <div class="panel-header" (click)="togglePanel('info')">
      <div class="ph-left">
        <span class="ph-icon ph-icon-info">
          <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
            <circle cx="6.5" cy="6.5" r="5.5" stroke="currentColor" stroke-width="1.2" />
            <path d="M6.5 6v3.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" />
            <circle cx="6.5" cy="4" r="0.8" fill="currentColor" />
          </svg>
        </span>
        <span class="ph-title">WORKFLOW INFO</span>
      </div>
      <div class="ph-right">
        <span class="ph-summary">{{ workflow.workflowName }} &middot; {{ workflow.status }}</span>
        <svg class="ph-chevron" [class.open]="panels.info" width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path d="M3 4.5l3 3 3-3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
    </div>
    <div class="panel-body" *ngIf="panels.info">
      <div class="form-grid">
        <div class="form-field">
          <label>Workflow Name</label>
          <input type="text" [ngModel]="workflow.workflowName" (ngModelChange)="updateField('workflowName', $event)" />
        </div>
        <div class="form-field">
          <label>Entity Name</label>
          <input type="text" [ngModel]="workflow.entityName" (ngModelChange)="updateField('entityName', $event)" />
        </div>
        <div class="form-field">
          <label>File Name</label>
          <input type="text" [ngModel]="workflow.fileName" (ngModelChange)="updateField('fileName', $event)" />
        </div>
        <div class="form-field">
          <label>Type</label>
          <select [ngModel]="workflow.type" (ngModelChange)="updateField('type', $event)">
            <option value="INBOUND">INBOUND</option>
            <option value="OUTBOUND">OUTBOUND</option>
          </select>
        </div>
        <div class="form-field">
          <label>Status</label>
          <select [ngModel]="workflow.status" (ngModelChange)="updateField('status', $event)">
            <option value="DRAFT">DRAFT</option>
            <option value="ACTIVE">ACTIVE</option>
            <option value="DISABLED">DISABLED</option>
          </select>
        </div>
      </div>
    </div>
  </div>

  <div class="config-panel">
    <div class="panel-header" (click)="togglePanel('samay')">
      <div class="ph-left">
        <span class="ph-icon ph-icon-samay">
          <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
            <circle cx="6.5" cy="6.5" r="5.5" stroke="currentColor" stroke-width="1.2" />
            <path d="M6.5 3.5v3l2 1.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </span>
        <span class="ph-title">SAMAY SCHEDULER</span>
      </div>
      <div class="ph-right">
        <div class="toggle-chip" [class.enabled]="workflow.samayEnabled" (click)="updateField('samayEnabled', !workflow.samayEnabled); $event.stopPropagation()">
          {{ workflow.samayEnabled ? 'ON' : 'OFF' }}
        </div>
        <span class="ph-summary" *ngIf="workflow.samayEnabled">{{ workflow.startTime || '-' }}</span>
        <svg class="ph-chevron" [class.open]="panels.samay" width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path d="M3 4.5l3 3 3-3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
    </div>
    <div class="panel-body" *ngIf="panels.samay">
      <div class="form-grid">
        <div class="form-field form-field-full">
          <label>Start Time</label>
          <input type="text" placeholder="e.g. DAILY_14_22_15" [ngModel]="workflow.startTime" (ngModelChange)="updateField('startTime', $event)" />
        </div>
        <div class="form-field">
          <label>Poll Time (ms)</label>
          <input type="number" [ngModel]="workflow.pollTime" (ngModelChange)="updateField('pollTime', $event)" />
          <span class="field-hint" *ngIf="workflow.pollTime">{{ msToHuman(workflow.pollTime) }}</span>
        </div>
        <div class="form-field">
          <label>Poll Interval (ms)</label>
          <input type="number" [ngModel]="workflow.pollInterval" (ngModelChange)="updateField('pollInterval', $event)" />
          <span class="field-hint" *ngIf="workflow.pollInterval">{{ msToHuman(workflow.pollInterval) }} &middot; max {{ maxRetries() }} retries</span>
        </div>
      </div>
    </div>
  </div>

  <div class="config-panel">
    <div class="panel-header" (click)="togglePanel('source')">
      <div class="ph-left">
        <span class="ph-icon ph-icon-source">
          <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
            <rect x="1" y="3" width="11" height="7" rx="1.5" stroke="currentColor" stroke-width="1.2" />
            <path d="M4 6.5h5M4 8.5h3" stroke="currentColor" stroke-width="1" stroke-linecap="round" />
          </svg>
        </span>
        <span class="ph-title">SOURCE CONFIG</span>
      </div>
      <div class="ph-right">
        <div class="source-type-tabs">
          <button class="src-tab" *ngFor="let sourceType of SOURCE_TYPES" [class.active]="workflow.sourceType === sourceType" (click)="updateField('sourceType', sourceType); $event.stopPropagation()">
            {{ sourceType === 'SFTP_SOURCE' ? 'SFTP' : sourceType === 'DB_SOURCE' ? 'DB' : 'API' }}
          </button>
        </div>
        <svg class="ph-chevron" [class.open]="panels.source" width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path d="M3 4.5l3 3 3-3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
    </div>
    <div class="panel-body" *ngIf="panels.source">
      <ng-container *ngIf="workflow.sourceType === 'SFTP_SOURCE'">
        <div class="form-grid">
          <div class="form-field">
            <label>Hostname</label>
            <input type="text" [ngModel]="workflow.sftp_hostname" (ngModelChange)="updateField('sftp_hostname', $event)" />
          </div>
          <div class="form-field form-field-sm">
            <label>Port</label>
            <input type="number" [ngModel]="workflow.sftp_port" (ngModelChange)="updateField('sftp_port', +$event)" />
          </div>
          <div class="form-field">
            <label>Username</label>
            <input type="text" [ngModel]="workflow.sftp_username" (ngModelChange)="updateField('sftp_username', $event)" />
          </div>
          <div class="form-field">
            <label>Remote Path</label>
            <input type="text" [ngModel]="workflow.sftp_remotePath" (ngModelChange)="updateField('sftp_remotePath', $event)" />
          </div>
          <div class="form-field">
            <label>Local Directory</label>
            <input type="text" [ngModel]="workflow.sftp_localDir" (ngModelChange)="updateField('sftp_localDir', $event)" />
          </div>
          <div class="form-field">
            <label>Private Key Path</label>
            <input type="text" [ngModel]="workflow.sftp_privateKey" (ngModelChange)="updateField('sftp_privateKey', $event)" />
          </div>
          <div class="form-field">
            <label>Passphrase</label>
            <input type="password" [ngModel]="workflow.sftp_passphrase" (ngModelChange)="updateField('sftp_passphrase', $event)" />
          </div>
          <div class="form-field form-field-sm">
            <label>Split Size</label>
            <input type="number" [ngModel]="workflow.sftp_splitSize" (ngModelChange)="updateField('sftp_splitSize', +$event)" />
          </div>
          <div class="form-field form-field-toggle">
            <label>SFTP Enabled</label>
            <div class="toggle-switch" [class.on]="workflow.sftp_enabled" (click)="updateField('sftp_enabled', !workflow.sftp_enabled)">
              <div class="toggle-knob"></div>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="workflow.sourceType === 'DB_SOURCE'">
        <div class="form-grid">
          <div class="form-field">
            <label>Entity Name</label>
            <input type="text" [ngModel]="workflow.db_entityName" (ngModelChange)="updateField('db_entityName', $event)" />
          </div>
          <div class="form-field">
            <label>Filter Name</label>
            <input type="text" [ngModel]="workflow.db_filterName" (ngModelChange)="updateField('db_filterName', $event)" />
          </div>
        </div>
        <div class="sub-section">
          <div class="sub-section-header"><span>Parameters</span><span class="sub-count">{{ workflow.db_parameters.length }}</span></div>
          <div class="kv-table" *ngIf="workflow.db_parameters.length">
            <div class="kv-row kv-head"><span>Key</span><span>Value</span><span></span></div>
            <div class="kv-row" *ngFor="let param of workflow.db_parameters; let index = index; trackBy: trackById">
              <input type="text" [(ngModel)]="param.key" (ngModelChange)="persist()" />
              <input type="text" [(ngModel)]="param.value" (ngModelChange)="persist()" />
              <button class="btn-remove-row" (click)="removeDBParam(index)">x</button>
            </div>
          </div>
          <div class="add-row">
            <input type="text" placeholder="key" [(ngModel)]="newDBParam.key" />
            <input type="text" placeholder="value" [(ngModel)]="newDBParam.value" />
            <button class="btn-add-row" (click)="addDBParam()">+ Add</button>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="workflow.sourceType === 'API_SOURCE'">
        <div class="form-grid">
          <div class="form-field form-field-full">
            <label>API Endpoint</label>
            <input type="text" [ngModel]="workflow.api_endpoint" (ngModelChange)="updateField('api_endpoint', $event)" />
          </div>
          <div class="form-field">
            <label>Data Path</label>
            <input type="text" [ngModel]="workflow.api_dataPath" (ngModelChange)="updateField('api_dataPath', $event)" />
          </div>
        </div>
        <div class="sub-section">
          <div class="sub-section-header"><span>Query Parameters</span><span class="sub-count">{{ workflow.api_parameters.length }}</span></div>
          <div class="kv-table" *ngIf="workflow.api_parameters.length">
            <div class="kv-row kv-head"><span>Key</span><span>Value</span><span></span></div>
            <div class="kv-row" *ngFor="let param of workflow.api_parameters; let index = index; trackBy: trackById">
              <input type="text" [(ngModel)]="param.key" (ngModelChange)="persist()" />
              <input type="text" [(ngModel)]="param.value" (ngModelChange)="persist()" />
              <button class="btn-remove-row" (click)="removeAPIParam(index)">x</button>
            </div>
          </div>
          <div class="add-row">
            <input type="text" placeholder="key" [(ngModel)]="newAPIParam.key" />
            <input type="text" placeholder="value" [(ngModel)]="newAPIParam.value" />
            <button class="btn-add-row" (click)="addAPIParam()">+ Add</button>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <div class="config-panel">
    <div class="panel-header" (click)="togglePanel('ttm')">
      <div class="ph-left">
        <span class="ph-icon ph-icon-ttm">
          <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
            <path d="M2 2h4v4H2z" stroke="currentColor" stroke-width="1.2" />
            <path d="M7 7h4v4H7z" stroke="currentColor" stroke-width="1.2" />
            <path d="M6 4h1.5M6 4v1.5M7 9H5.5M7 9V7.5" stroke="currentColor" stroke-width="1" stroke-linecap="round" />
          </svg>
        </span>
        <span class="ph-title">TTM RULES</span>
      </div>
      <div class="ph-right">
        <div class="toggle-chip" [class.enabled]="workflow.ttmEnabled" (click)="updateField('ttmEnabled', !workflow.ttmEnabled); $event.stopPropagation()">{{ workflow.ttmEnabled ? 'ON' : 'OFF' }}</div>
        <span class="ph-summary">{{ workflow.sourceMetadata.length }} src &middot; {{ workflow.targetMetadata.length }} map</span>
        <svg class="ph-chevron" [class.open]="panels.ttm" width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path d="M3 4.5l3 3 3-3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
    </div>
    <div class="panel-body" *ngIf="panels.ttm">
      <div class="sub-section">
        <div class="sub-section-header"><span>Source Metadata</span><span class="sub-count">{{ workflow.sourceMetadata.length }}</span></div>
        <div class="data-table" *ngIf="workflow.sourceMetadata.length">
          <div class="dt-row dt-head"><span>Column Name</span><span>Data Type</span><span>Date Format</span><span></span></div>
          <div class="dt-row" *ngFor="let field of workflow.sourceMetadata; let index = index; trackBy: trackById">
            <input type="text" [(ngModel)]="field.columnName" (ngModelChange)="persist()" />
            <select [(ngModel)]="field.dataType" (ngModelChange)="persist()">
              <option *ngFor="let dataType of DATA_TYPES" [value]="dataType">{{ dataType }}</option>
            </select>
            <input type="text" [ngModel]="field.sourceDateFormat || ''" (ngModelChange)="field.sourceDateFormat = $event; persist()" placeholder="yyyy-MM-dd" />
            <button class="btn-remove-row" (click)="removeSMField(index)">x</button>
          </div>
        </div>
        <div class="add-row add-row-3">
          <input type="text" placeholder="columnName" [(ngModel)]="newSMField.columnName" />
          <select [(ngModel)]="newSMField.dataType">
            <option *ngFor="let dataType of DATA_TYPES" [value]="dataType">{{ dataType }}</option>
          </select>
          <button class="btn-add-row" (click)="addSMField()">+ Add</button>
        </div>
      </div>

      <div class="sub-section">
        <div class="sub-section-header"><span>Target Mappings</span><span class="sub-count">{{ workflow.targetMetadata.length }}</span></div>
        <div class="tm-card" *ngFor="let mapping of workflow.targetMetadata; let index = index; trackBy: trackById">
          <div class="tm-card-header" (click)="toggleTMExpand(mapping.id)">
            <div class="tm-card-left">
              <span class="tm-src-attrs">{{ mapping.attributes || '-' }}</span>
              <svg class="tm-flow-arrow" width="12" height="10" viewBox="0 0 12 10" fill="none">
                <path d="M1 5h10M7.5 1.5L11 5l-3.5 3.5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <span class="tm-target-field">{{ mapping.mapTo || 'untitled' }}</span>
            </div>
            <div class="tm-card-right">
              <span class="tm-step-count" *ngIf="mapping.steps.length">{{ mapping.steps.length }} step{{ mapping.steps.length !== 1 ? 's' : '' }}</span>
              <span class="tm-filt-badge" *ngIf="mapping.filtrationRules.length">{{ mapping.filtrationRules.length }} filter{{ mapping.filtrationRules.length !== 1 ? 's' : '' }}</span>
              <span class="tm-type-pill tm-tp-{{ mapping.dataType }}">{{ mapping.dataType }}</span>
              <svg class="tm-chevron" [class.open]="mapping.expanded" width="11" height="11" viewBox="0 0 11 11" fill="none">
                <path d="M2 4l3.5 3.5L9 4" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <button class="tm-remove" (click)="removeTMMapping(index); $event.stopPropagation()">x</button>
            </div>
          </div>
          <div class="tm-card-body" *ngIf="mapping.expanded">
            <div class="form-grid">
              <div class="form-field">
                <label>Map To (target field)</label>
                <input type="text" [(ngModel)]="mapping.mapTo" (ngModelChange)="persist()" />
              </div>
              <div class="form-field">
                <label>Source Attributes</label>
                <input type="text" [(ngModel)]="mapping.attributes" (ngModelChange)="persist()" placeholder="col1, col2..." />
              </div>
              <div class="form-field form-field-sm">
                <label>Target Type</label>
                <select [(ngModel)]="mapping.dataType" (ngModelChange)="persist()">
                  <option *ngFor="let dataType of DATA_TYPES" [value]="dataType">{{ dataType }}</option>
                </select>
              </div>
            </div>

            <div class="tm-sub-header"><span>Filtration Rules</span><button class="btn-add-step" (click)="openAddFilt(mapping.id); $event.stopPropagation()">+ Add Filter</button></div>
            <div class="filt-rule-list" *ngIf="mapping.filtrationRules.length">
              <div class="filt-rule-row" *ngFor="let filterRule of mapping.filtrationRules; let filterIndex = index; trackBy: trackById">
                <select [(ngModel)]="filterRule.operator" (ngModelChange)="persist()">
                  <option *ngFor="let filterOp of FILTER_OPS" [value]="filterOp">{{ filterOp }}</option>
                </select>
                <input type="text" placeholder="attributes" [(ngModel)]="filterRule.attributes" (ngModelChange)="persist()" />
                <input type="text" placeholder="value" [(ngModel)]="filterRule.value" (ngModelChange)="persist()" *ngIf="filtOpNeedsValue(filterRule.operator)" />
                <button class="btn-remove-row" (click)="removeFiltRule(mapping.id, filterIndex); $event.stopPropagation()">x</button>
              </div>
            </div>
            <div class="filt-empty" *ngIf="!mapping.filtrationRules.length && addFiltFor !== mapping.id">No filtration rules defined</div>
            <div class="filt-add-form" *ngIf="addFiltFor === mapping.id">
              <select [(ngModel)]="newFiltRule.operator">
                <option *ngFor="let filterOp of FILTER_OPS" [value]="filterOp">{{ filterOp }}</option>
              </select>
              <input type="text" placeholder="attributes" [(ngModel)]="newFiltRule.attributes" />
              <input type="text" placeholder="value" [(ngModel)]="newFiltRule.value" *ngIf="filtOpNeedsValue(newFiltRule.operator)" />
              <button class="btn-confirm-step" (click)="addFiltRule(mapping.id)">Add</button>
              <button class="btn-cancel-inline" (click)="addFiltFor = null">Cancel</button>
            </div>

            <div class="tm-sub-header"><span>Transformation Steps</span><button class="btn-add-step" (click)="openAddStep(mapping.id); $event.stopPropagation()">+ Add Step</button></div>
            <div class="step-flow">
              <div class="step-source-pill"><span class="sf-pill-label">SOURCE</span><span class="sf-pill-attrs">{{ mapping.attributes || '-' }}</span></div>
              <ng-container *ngFor="let step of mapping.steps; let stepIndex = index; trackBy: trackById">
                <div class="step-connector"><div class="sc-line"></div><div class="sc-arrow"><svg width="8" height="6" viewBox="0 0 8 6" fill="none"><path d="M4 6L0 0h8L4 6z" fill="currentColor" /></svg></div></div>
                <div class="step-card">
                  <div class="sc-step-num">{{ step.step }}</div>
                  <div class="sc-fields">
                    <div class="sf-row">
                      <div class="sf-group"><label>Input</label><input type="text" class="sf-input" [(ngModel)]="step.inputAttrs" (ngModelChange)="persist()" placeholder="attr / prev output" /></div>
                      <div class="sf-group"><label>Operation</label><select class="sf-select" [(ngModel)]="step.operation" (ngModelChange)="persist()"><option *ngFor="let op of TTM_OPS" [value]="op">{{ opLabel(op) }}</option></select></div>
                      <div class="sf-group sf-group-sm" *ngIf="opNeedsRange(step.operation)"><label>{{ rangeLabel(step.operation)[0] }}</label><input type="text" class="sf-param" [(ngModel)]="step.rangeStart" (ngModelChange)="persist()" /></div>
                      <div class="sf-group sf-group-sm" *ngIf="opNeedsRange(step.operation)"><label>{{ rangeLabel(step.operation)[1] }}</label><input type="text" class="sf-param" [(ngModel)]="step.rangeEnd" (ngModelChange)="persist()" /></div>
                      <div class="sf-group sf-group-sm" *ngIf="opNeedsSeparator(step.operation)"><label>{{ separatorLabel(step.operation) }}</label><input type="text" class="sf-param" [(ngModel)]="step.separator" (ngModelChange)="persist()" /></div>
                      <div class="sf-group sf-group-wide"><label>Output name</label><input type="text" class="sf-input" [(ngModel)]="step.output" (ngModelChange)="persist()" placeholder="output variable" /></div>
                    </div>
                  </div>
                  <button class="sc-remove" (click)="removeTtmStep(mapping.id, stepIndex); $event.stopPropagation()">x</button>
                </div>
              </ng-container>
              <ng-container *ngIf="addStepFor === mapping.id">
                <div class="step-connector"><div class="sc-line"></div><div class="sc-arrow"><svg width="8" height="6" viewBox="0 0 8 6" fill="none"><path d="M4 6L0 0h8L4 6z" fill="currentColor" /></svg></div></div>
                <div class="step-add-form">
                  <div class="saf-num">{{ mapping.steps.length + 1 }}</div>
                  <div class="sc-fields">
                    <div class="sf-row">
                      <div class="sf-group"><label>Input</label><input type="text" class="sf-input" [(ngModel)]="newStep.inputAttrs" placeholder="attr / prev output" /></div>
                      <div class="sf-group"><label>Operation</label><select class="sf-select" [(ngModel)]="newStep.operation"><option *ngFor="let op of TTM_OPS" [value]="op">{{ opLabel(op) }}</option></select></div>
                      <div class="sf-group sf-group-sm" *ngIf="opNeedsRange(newStep.operation)"><label>{{ rangeLabel(newStep.operation)[0] }}</label><input type="text" class="sf-param" [(ngModel)]="newStep.rangeStart" /></div>
                      <div class="sf-group sf-group-sm" *ngIf="opNeedsRange(newStep.operation)"><label>{{ rangeLabel(newStep.operation)[1] }}</label><input type="text" class="sf-param" [(ngModel)]="newStep.rangeEnd" /></div>
                      <div class="sf-group sf-group-sm" *ngIf="opNeedsSeparator(newStep.operation)"><label>{{ separatorLabel(newStep.operation) }}</label><input type="text" class="sf-param" [(ngModel)]="newStep.separator" /></div>
                      <div class="sf-group sf-group-wide"><label>Output name</label><input type="text" class="sf-input" [(ngModel)]="newStep.output" placeholder="output variable" /></div>
                    </div>
                    <div class="sf-actions"><button class="btn-confirm-step" (click)="addTtmStep(mapping.id)">Add Step</button><button class="btn-cancel-inline" (click)="addStepFor = null">Cancel</button></div>
                  </div>
                </div>
              </ng-container>
              <div class="step-connector" *ngIf="mapping.steps.length || addStepFor === mapping.id"><div class="sc-line"></div><div class="sc-arrow"><svg width="8" height="6" viewBox="0 0 8 6" fill="none"><path d="M4 6L0 0h8L4 6z" fill="currentColor" /></svg></div></div>
              <div class="step-target-pill"><span class="sf-pill-label">TARGET</span><span class="sf-pill-attrs">{{ mapping.mapTo || '-' }}</span></div>
            </div>
          </div>
        </div>
        <div class="tm-add-row">
          <input type="text" placeholder="target field name" [(ngModel)]="newTMMapping.mapTo" />
          <input type="text" placeholder="source attributes" [(ngModel)]="newTMMapping.attributes" />
          <select [(ngModel)]="newTMMapping.dataType"><option *ngFor="let dataType of DATA_TYPES" [value]="dataType">{{ dataType }}</option></select>
          <button class="btn-add-row" (click)="addTMMapping()" [disabled]="!newTMMapping.mapTo.trim()">+ Add Mapping</button>
        </div>
      </div>

      <div class="sub-section">
        <div class="sub-section-header"><span>Global Record Filters</span><span class="sub-count">{{ workflow.globalFilters.length }}</span></div>
        <div class="kv-table gf-table" *ngIf="workflow.globalFilters.length">
          <div class="kv-row kv-head"><span>Attribute</span><span>Operator</span><span>Value</span><span></span></div>
          <div class="kv-row" *ngFor="let filterRow of workflow.globalFilters; let index = index; trackBy: trackById">
            <input type="text" [(ngModel)]="filterRow.attribute" (ngModelChange)="persist()" />
            <select [(ngModel)]="filterRow.operator" (ngModelChange)="persist()"><option *ngFor="let op of GF_OPERATORS" [value]="op">{{ op }}</option></select>
            <input type="text" [(ngModel)]="filterRow.value" (ngModelChange)="persist()" />
            <button class="btn-remove-row" (click)="removeGFilter(index)">x</button>
          </div>
        </div>
        <div class="add-row add-row-3">
          <input type="text" placeholder="attribute" [(ngModel)]="newGFRow.attribute" />
          <select [(ngModel)]="newGFRow.operator"><option *ngFor="let op of GF_OPERATORS" [value]="op">{{ op }}</option></select>
          <button class="btn-add-row" (click)="addGFilter()">+ Add</button>
        </div>
      </div>
    </div>
  </div>

  <div class="config-panel">
    <div class="panel-header" (click)="togglePanel('sink')">
      <div class="ph-left">
        <span class="ph-icon ph-icon-sink">
          <svg width="13" height="13" viewBox="0 0 13 13" fill="none"><path d="M2 10h9M6.5 2v8M3.5 5.5l3 3 3-3" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" /></svg>
        </span>
        <span class="ph-title">SINK CONFIG</span>
      </div>
      <div class="ph-right">
        <div class="source-type-tabs">
          <button class="src-tab" *ngFor="let sinkType of SINK_TYPES" [class.active]="workflow.sinkType === sinkType" (click)="updateField('sinkType', sinkType); $event.stopPropagation()">
            {{ sinkType === 'GRPC_SINK' ? 'GRPC' : sinkType === 'API_SINK' ? 'API' : 'CSV' }}
          </button>
        </div>
        <svg class="ph-chevron" [class.open]="panels.sink" width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M3 4.5l3 3 3-3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
      </div>
    </div>
    <div class="panel-body" *ngIf="panels.sink">
      <div class="form-grid">
        <ng-container *ngIf="workflow.sinkType === 'GRPC_SINK' || workflow.sinkType === 'API_SINK'">
          <div class="form-field form-field-full"><label>API URL</label><input type="text" [ngModel]="workflow.sink_apiUrl" (ngModelChange)="updateField('sink_apiUrl', $event)" /></div>
          <div class="form-field form-field-full"><label>Encrypt Key Path</label><input type="text" [ngModel]="workflow.sink_encryptKey" (ngModelChange)="updateField('sink_encryptKey', $event)" /></div>
        </ng-container>
        <ng-container *ngIf="workflow.sinkType === 'CSV_SINK'">
          <div class="form-field form-field-full"><label>CSV Output Path</label><input type="text" [ngModel]="workflow.sink_csvPath" (ngModelChange)="updateField('sink_csvPath', $event)" /></div>
        </ng-container>
      </div>
      <div class="sub-section" *ngIf="workflow.sinkType === 'GRPC_SINK' || workflow.sinkType === 'API_SINK'">
        <div class="sub-section-header"><span>Service Endpoints</span><span class="sub-count">{{ workflow.serviceEndpoints.length }}</span></div>
        <div class="data-table" *ngIf="workflow.serviceEndpoints.length">
          <div class="dt-row dt-head"><span>Version</span><span>Function Name</span><span></span></div>
          <div class="dt-row" *ngFor="let endpoint of workflow.serviceEndpoints; let index = index; trackBy: trackById">
            <input type="text" [(ngModel)]="endpoint.version" (ngModelChange)="persist()" />
            <input type="text" [(ngModel)]="endpoint.functionName" (ngModelChange)="persist()" />
            <button class="btn-remove-row" (click)="removeSvcEP(index)">x</button>
          </div>
        </div>
        <div class="add-row">
          <input type="text" placeholder="version" [(ngModel)]="newSvcEP.version" />
          <input type="text" placeholder="functionName" [(ngModel)]="newSvcEP.functionName" />
          <button class="btn-add-row" (click)="addServiceEP()">+ Add</button>
        </div>
      </div>
    </div>
  </div>

  <div class="config-panel config-panel-last">
    <div class="panel-header" (click)="togglePanel('routing')">
      <div class="ph-left">
        <span class="ph-icon ph-icon-routing">
          <svg width="13" height="13" viewBox="0 0 13 13" fill="none"><path d="M2 6.5h9M7 3.5l3.5 3-3.5 3" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" /></svg>
        </span>
        <span class="ph-title">ROUTING &amp; CRUD</span>
      </div>
      <div class="ph-right">
        <span class="ph-summary">{{ workflow.crudOperation || 'no op' }} &middot; {{ workflow.businessKeys.length }} key{{ workflow.businessKeys.length !== 1 ? 's' : '' }}</span>
        <svg class="ph-chevron" [class.open]="panels.routing" width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M3 4.5l3 3 3-3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
      </div>
    </div>
    <div class="panel-body" *ngIf="panels.routing">
      <div class="form-grid">
        <div class="form-field">
          <label>CRUD Operation</label>
          <select [ngModel]="workflow.crudOperation" (ngModelChange)="updateField('crudOperation', $event)">
            <option *ngFor="let crudOp of CRUD_OPS" [value]="crudOp">{{ crudOp || '- none -' }}</option>
          </select>
        </div>
      </div>
      <div class="sub-section">
        <div class="sub-section-header"><span>Business Keys</span><span class="sub-count">{{ workflow.businessKeys.length }}</span></div>
        <div class="biz-keys" *ngIf="workflow.businessKeys.length">
          <span class="biz-key-chip" *ngFor="let businessKey of workflow.businessKeys; let index = index">{{ businessKey }} <button class="bk-remove" (click)="removeBizKey(index)">x</button></span>
        </div>
        <div class="add-row add-row-inline"><input type="text" placeholder="business key field" [(ngModel)]="newBizKey" (keydown.enter)="addBizKey()" /><button class="btn-add-row" (click)="addBizKey()">+ Add</button></div>
      </div>
      <div class="sub-section">
        <div class="sub-section-header"><span>Chain Links</span></div>
        <div class="form-grid">
          <div class="form-field"><label>Previous WF ID</label><div class="chain-input-wrap"><svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M4 8V4a2 2 0 0 1 4 0" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" /><path d="M4 8a2 2 0 0 0 4 0" stroke="currentColor" stroke-width="1.2" /></svg><input type="text" class="chain-input" [ngModel]="workflow.previousWFId" (ngModelChange)="updateField('previousWFId', $event)" placeholder="upstream workflow id" /></div></div>
          <div class="form-field"><label>Next WF ID</label><div class="chain-input-wrap"><svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M4 8V4a2 2 0 0 1 4 0" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" /><path d="M4 8a2 2 0 0 0 4 0" stroke="currentColor" stroke-width="1.2" /></svg><input type="text" class="chain-input" [ngModel]="workflow.nextWFId" (ngModelChange)="updateField('nextWFId', $event)" placeholder="downstream workflow id" /></div></div>
        </div>
      </div>
    </div>
  </div>
</div>
